import { useEffect } from "react";
import useSPUndo from "../../../hooks/useSPUndo";

const useLoadSPPositionToEdit = (
  axiosPrivate,
  positiontoedit,
  setposition,
  setpositionData,
  setPaymentterm,
  setPaymenttermData,
  paytermInit,
  paytermDataInit,
  setLoaded,
  navigate,
  location
) => {
  const { positionEditsSP, undoListSP } = useSPUndo();
  useEffect(() => {
    if (positiontoedit) {
      const loadpositiontoedit = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadsppositiontoedit", {
            positionID: positiontoedit,
          });
          setposition(response.data[0]);
          setLoaded((prev) => !prev);
          positionEditsSP.current = [];
          undoListSP.current = [];
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadpositiondatatoedit = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadsppositiondatatoedit", {
            positionID: positiontoedit,
          });
          setpositionData(response.data[0]);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadpospayterms = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadSPpospayterms", {
            positionID: positiontoedit,
          });
          if (response.data.message === "No payterms exist.") {
            setPaymentterm(paytermInit);
          } else setPaymentterm(response.data);
        } catch {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadpospaytermsdata = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadSPpospaytermsdata", {
            positionID: positiontoedit,
          });
          if (response.data.message === "No payterms exist.") {
            setPaymenttermData(paytermDataInit);
          } else setPaymenttermData(response.data);
        } catch {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      loadpositiontoedit();
      loadpositiondatatoedit();
      loadpospayterms();
      loadpospaytermsdata();
    }
  }, [positiontoedit]);
};

export default useLoadSPPositionToEdit;
